import { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";

export const posFee = (rule, amount) => {
  if (!rule || !(amount > 0)) return 0;
  const v = Number(rule.value || 0);
  return Math.round((rule.type === "percent" ? (amount * v) / 100 : v) * 100) / 100;
};

export function usePosCharge() {
  const { authAxios } = useAuth();
  const [rule, setRule] = useState(null);
  useEffect(() => {
    authAxios.get("/finance-admin/settings/pos-charges").then(r => setRule(r.data)).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return rule;
}

export function PosFeeNote({ rule, amount, testid }) {
  const fee = posFee(rule, amount);
  if (!fee) return null;
  return (
    <div className="mt-3 bg-amber-50 rounded-xl p-3 text-sm" data-testid={testid}>
      <p className="text-slate-700">Payment processing charges: <strong className="text-amber-700">€{fee.toFixed(2)}</strong> ({rule.type === "percent" ? `${rule.value}%` : "flat"})</p>
      <p className="font-bold text-[#1e3a5f]">Buyer pays: €{(amount + fee).toFixed(2)}</p>
    </div>
  );
}
